import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "railBottom " }
const _hoisted_2 = { class: "railBottom__action" }
const _hoisted_3 = /*#__PURE__*/_createVNode("button", { class: "search-card-footer-controls__dropdown" }, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.item.ckTrainListReferences, (category) => {
      return (_openBlock(), _createBlock("div", {
        class: "infoPrice",
        key: category.categoryCarriage
      }, [
        _createTextVNode(_toDisplayString(category.categoryCarriagePrinted ? category.categoryCarriagePrinted : category.categoryCarriage) + ": от ", 1 /* TEXT */),
        _createVNode("b", null, _toDisplayString(category.costTicket), 1)
      ]))
    }), 128 /* KEYED_FRAGMENT */)),
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.isSelected)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createVNode("button", {
              class: "search-card-footer-controls__submit",
              onClick: _cache[1] || (_cache[1] = $event => (_ctx.openPricingModal(_ctx.item && _ctx.item.numberTrain ? _ctx.item.numberTrain : null)))
            }, " Изменить "),
            _createVNode("button", {
              class: "btn-close btn-close--border btn-close--small ml-8",
              onClick: _cache[2] || (_cache[2] = _withModifiers($event => (_ctx.unselect()), ["prevent"]))
            })
          ], 64 /* STABLE_FRAGMENT */))
        : (_openBlock(), _createBlock("button", {
            key: 1,
            class: "search-card-footer-controls__submit",
            onClick: _cache[3] || (_cache[3] = $event => (_ctx.openPricingModal(_ctx.item && _ctx.item.numberTrain ? _ctx.item.numberTrain : null)))
          }, " Выбрать "))
    ])
  ]))
}